import styleTheme from './styleTheme'
import logo from '@images/logo.png'
import coverImg from '@images/login/login_bg.png'

import AppBar from '@components/AppBar'
import { transform } from '@utils/intl_lang'
const theme = {
  id: 'default',
  styleTheme,
  logo,
  coverImg,
  // 'e祺学'
  platformName: transform('zhiniao_portal'),
  title: '学习平台',
  components: {
    AppBar,
  },
}

export default theme
